import type { AxiosResponse } from "axios";

import { instance } from "./AxiosInstance";
import {
  getHeaders,
  type CPFData,
  type DownloadType,
} from "./RequestHeaders";
import { handleRequestError } from "./RequestError";

export interface RequestOptions<TBody = unknown> {
  body?: TBody;
}

export const postRequest = async <TBody = unknown>(
  url: string,
  options: RequestOptions<TBody>,
  cpf: CPFData | null = null,
  download: DownloadType = null
): Promise<AxiosResponse | null> => {
  try {
    const config = getHeaders(cpf, download);
    const response = await instance.post(url, options.body, config);
    return response;
  } catch (exception) {
    return handleRequestError(exception);
  }
};

export const patchRequest = async <TBody = unknown>(
  url: string,
  options: RequestOptions<TBody>,
  cpf: CPFData | null = null
): Promise<AxiosResponse | null> => {
  try {
    const config = getHeaders(cpf);
    const response = await instance.patch(url, options.body, config);
    return response;
  } catch (exception) {
    return handleRequestError(exception);
  }
};

export const putRequest = async <TBody = unknown>(
  url: string,
  options: RequestOptions<TBody>,
  cpf: CPFData | null = null
): Promise<AxiosResponse | null> => {
  try {
    const config = getHeaders(cpf);
    const response = await instance.put(url, options.body, config);
    return response;
  } catch (exception) {
    return handleRequestError(exception);
  }
};

export const getRequest = async (
  url: string,
  cpf: CPFData | null = null
): Promise<AxiosResponse | null> => {
  try {
    const config = getHeaders(cpf);
    const response = await instance.get(url, config);
    return response;
  } catch (exception) {
    return handleRequestError(exception);
  }
};

export const deleteRequest = async (
  url: string
): Promise<AxiosResponse | null> => {
  try {
    const config = getHeaders();
    const response = await instance.delete(url, config);
    return response;
  } catch (exception) {
    return handleRequestError(exception);
  }
};
